import _extends from "@babel/runtime/helpers/extends";
import React from 'react';
import { SvgIcon, SvgFill } from '@chegg-ui/svg-icon';
var GoogleDark = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIcon, _extends({}, props, {
    ref: ref
  }), /*#__PURE__*/React.createElement(SvgFill, {
    svgColor: "#fff",
    d: "M0 0h44v44H0z"
  }), /*#__PURE__*/React.createElement(SvgFill, {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M43.055 18h-20.66v8.51h11.84a10.121 10.121 0 0 1-4.389 6.636 13.273 13.273 0 0 1-7.45 2.105 13.26 13.26 0 0 1 0-26.508 11.853 11.853 0 0 1 8.405 3.292l6.314-6.314a21.136 21.136 0 0 0-14.72-5.72 21.995 21.995 0 1 0 0 43.991 21.02 21.02 0 0 0 14.565-5.32 21.484 21.484 0 0 0 6.56-16.178 25.288 25.288 0 0 0-.465-4.493Z",
    svgColor: "#302C41"
  }));
});
GoogleDark.displayName = 'GoogleDark';
GoogleDark.defaultProps = {
  'aria-label': 'GoogleDark'
};
export default GoogleDark;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@chegg-ui/horizon-icons/dist/esm/icons/Logo/GoogleDark.js
// module id = 2950
// module chunks = 11